import React, { Component } from "react";
import PropTypes from "prop-types";
import { Mutation } from "@apollo/react-components";
import { Modal, TextContainer } from "@shopify/polaris";
import { gql } from "apollo-boost";

class DeleteEbayButton extends Component {
  state = {
    visible: false,
  };
  render() {
    const { open, onClose } = this.state;
    const { store, refetch } = this.props;
    return (
      <Mutation
        mutation={gql`
          mutation deleteStore($id: ID!) {
            deleteStore(id: $id)
          }
        `}
      >
        {(deleteStore) => (
          <React.Fragment>
            {/* <Button
              onClick={() => {
                this.setState({ visible: true });
              }}
              size={"slim"}
              plain
              destructive
            >
              Delete
            </Button> */}
            <Modal
              // open={visible}
              // onClose={() => {
              //   this.setState({ visible: false });
              // }}
              open={open}
              onClose={onClose}
              title="Delete Ebay Account confirmation"
              primaryAction={{
                content: "Delete",
                onAction: () => {
                  deleteStore({
                    variables: {
                      id: store.id,
                    },
                  }).then(() => {
                    if (refetch) {
                      refetch();
                    }
                  });
                },
              }}
              secondaryActions={[
                {
                  content: "Cancel",
                  onAction: () => {
                    this.setState({ visible: false });
                  },
                },
              ]}
            >
              <Modal.Section>
                <TextContainer>
                  <p>
                    Are you sure want to delete <strong>{store.title}</strong>
                  </p>
                </TextContainer>
              </Modal.Section>
            </Modal>
          </React.Fragment>
        )}
      </Mutation>
    );
  }
}

DeleteEbayButton.propTypes = {
  store: PropTypes.any,
  refetch: PropTypes.any,
};

export default DeleteEbayButton;
